module.exports = __webpack_public_path__ + "img/scene1.e386efe6.jpg";